import { assign, createMachine } from 'xstate';
import { Context } from './types';

const customerData = createMachine<Context>({
  id: 'customerData',
  predictableActionArguments: true,
  context: {
    initialData: null,
  },
  on: {
    EDIT_CONTACT_DETAILS: {
      target: 'contactDetails.edit',
    },
    EDIT_SHIPPING_ADDRESS: {
      target: 'shippingAddress.edit',
    },
  },
  initial: 'idle',
  states: {
    idle: {
      on: {
        INITIALIZE: {
          target: 'loading',
        },
      },
    },
    loading: {
      invoke: {
        src: 'getCustomerData',
        onDone: {
          target: 'idle',
          actions: assign((_ctx, event) => {
            return {
              initialData: event.data,
            };
          }),
        },
        onError: {
          target: 'error',
        },
      },
    },
    error: {
      on: {
        INITIALIZE: {
          target: 'loading',
        },
      },
    },
    shippingAddress: {
      id: 'shippingAddress',
      initial: 'idle',
      states: {
        idle: {
          on: {
            EDIT: {
              target: 'edit',
            },
          },
        },
        edit: {
          id: 'shippingAddressEdit',
          initial: 'idle',
          states: {
            idle: {
              on: {
                SAVE: {
                  target: 'saving',
                },
                CANCEL: {
                  target: '#shippingAddress.idle',
                },
              },
            },
            saving: {
              invoke: {
                src: 'saveCustomerData',
                onDone: {
                  target: '#shippingAddress.idle',
                  actions: [
                    assign((_ctx, event) => {
                      return {
                        initialData: event.data,
                      };
                    }),
                    'onSuccessUpdate',
                  ],
                },
                onError: {
                  target: 'error',
                },
              },
            },
            error: {
              on: {
                CANCEL: {
                  target: '#shippingAddress.idle',
                },
                SAVE: {
                  target: 'saving',
                },
              },
            },
          },
        },
      },
    },
    contactDetails: {
      id: 'contactDetails',
      initial: 'idle',
      states: {
        idle: {
          on: {
            EDIT: {
              target: 'edit',
            },
          },
        },
        edit: {
          id: 'contactDetailsEdit',
          initial: 'idle',
          states: {
            idle: {
              on: {
                SAVE: {
                  target: 'saving',
                },
                CANCEL: {
                  target: '#contactDetails.idle',
                },
              },
            },
            saving: {
              invoke: {
                src: 'saveCustomerData',
                onDone: {
                  target: '#contactDetails.idle',
                  actions: [
                    assign((_ctx, event) => {
                      return {
                        initialData: event.data,
                      };
                    }),
                    'onSuccessUpdate',
                  ],
                },
                onError: {
                  target: 'error',
                },
              },
            },
            error: {
              on: {
                CANCEL: {
                  target: '#contactDetails.idle',
                },
                SAVE: {
                  target: 'saving',
                },
              },
            },
          },
        },
      },
    },
  },
});

export { customerData };
